/* eslint-disable complexity */
import { columnType } from 'components/table/types';
import _ from 'lodash';
import { Stack, Switch, useTheme } from '@mui/material';
import { CustomSwitch } from 'components/Inputs';
import { hasPermission } from 'components/AuthorizationComponent';
import { permissionEnums } from 'constants/permission.constants';

export const tableData = (data: any) => {
	return data.map((item: any) => ({
		...item,
	}));
};

export const tableColumns = {
	bankName: 'string',
	bankCode: 'integer',
	isDigitalDepositTemporarilyUnavailable: 'custom',
};

export const buildColumns = (
	t: any,
	handleEditButtonClick: any,
	saveBankChanges: any,
	cancelBankChanges: any,
	updateModifiedBanks: any
): columnType[] => {
	const theme = useTheme();
	const editPermissions = hasPermission([permissionEnums.EDIT_SYSTEM_SETTINGS]);

	const columns: columnType[] = [];
	_.keys(tableColumns).map((element: any) => {
		let customValueHandle = {};
		if (element === 'isDigitalDepositTemporarilyUnavailable') {
			customValueHandle = {
				customValueHandle: (value: any, row: Record<string, any>) => {
					const isDigitalDepositAvailable = value === false;

					return (
						<Stack direction={'row'} justifyContent={'space-between'} gap={10}>
							<CustomSwitch checked={isDigitalDepositAvailable} theme={theme}>
								<Switch
									checked={isDigitalDepositAvailable}
									disabled={!row.editable}
									onChange={
										editPermissions
											? (_event, checked) => updateModifiedBanks(element, !checked, row)
											: undefined
									}
								/>
							</CustomSwitch>
							{row.editable ? (
								<Stack gap={5} direction={'row'}>
									{editPermissions && (
										<>
											<img
												src={'icons/check.svg'}
												style={{ cursor: 'pointer' }}
												onClick={() => saveBankChanges(row)}
											/>
											<img
												src={'icons/cancel.svg'}
												style={{ cursor: 'pointer' }}
												onClick={() => cancelBankChanges()}
											/>
										</>
									)}
								</Stack>
							) : (
								<>
									{editPermissions && (
										<img
											src={'icons/pencil.svg'}
											style={{ cursor: 'pointer' }}
											onClick={() => handleEditButtonClick(row.id)}
										/>
									)}
								</>
							)}
						</Stack>
					);
				},
			};
		}
		const props: columnType = {
			fieldId: 'id',
			name: element,
			title: t('page.digital_deposit_bank_availability.field.' + element),
			type: _.get(tableColumns, element),
			sortable: true,
			...customValueHandle,
		};
		columns.push(props);
	});
	return columns;
};
